import { render, staticRenderFns } from "./DetailHistoryDoctorMasseuse.vue?vue&type=template&id=9e340d14&scoped=true&"
import script from "./DetailHistoryDoctorMasseuse.vue?vue&type=script&lang=js&"
export * from "./DetailHistoryDoctorMasseuse.vue?vue&type=script&lang=js&"
import style0 from "./DetailHistoryDoctorMasseuse.vue?vue&type=style&index=0&id=9e340d14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e340d14",
  null
  
)

export default component.exports